export default "__VITE_ASSET__C3U_iWoD__"